import { Spacer, TextField } from '@truepill/react-capsule'
import CloseButton from 'components/CloseButton'
import styled from 'styled-components'
import type { Condition } from '../CreateRuleSetPage'
import ArrayMethodSelect from './ArrayMethodSelect'
import FieldSelect from './FieldSelect'
import OperatorSelect from './OperatorSelect'
import TypeSelect from './TypeSelect'
import ValuesMultipleSelect from './ValuesMultipleSelect'
import ValuesTypeSelect from './ValuesTypeSelect'

const ConditionCard = ({
  index,
  cond,
  onChange,
  attemptedSubmit,
  onRemove,
}: {
  index: number
  cond: Condition
  onChange: (field: keyof Condition, value: any) => void
  attemptedSubmit: boolean
  onRemove?: () => void
}) => {
  return (
    <Container key={index}>
      <TypeSelect
        value={cond.type}
        onChange={val => onChange('type', val)}
        state={attemptedSubmit && !cond.type ? 'error' : 'default'}
        helperText={attemptedSubmit && !cond.type ? 'Type is required' : undefined}
      />
      <Spacer size="sm" />
      <FieldSelect
        value={cond.field}
        onChange={val => onChange('field', val)}
        state={attemptedSubmit && !cond.field ? 'error' : 'default'}
        helperText={attemptedSubmit && !cond.field ? 'Field is required' : undefined}
      />
      <Spacer size="sm" />
      {cond.type === 'MULTIPLE_VALUE' && (
        <>
          <ValuesTypeSelect
            value={cond.values_type || ''}
            onChange={val => onChange('values_type', val)}
            state={attemptedSubmit && !cond.values_type ? 'error' : 'default'}
            helperText={attemptedSubmit && !cond.values_type ? 'Values type is required' : undefined}
          />
          <Spacer size="sm" />
        </>
      )}
      <OperatorSelect
        value={cond.operator}
        onChange={val => onChange('operator', val)}
        type={cond.type}
        state={attemptedSubmit && !cond.operator ? 'error' : 'default'}
        helperText={attemptedSubmit && !cond.operator ? 'Operator is required' : undefined}
        valuesType={cond.values_type}
      />
      <Spacer size="sm" />
      {(cond.type === 'SINGLE_VALUE' || (cond.type === 'MULTIPLE_VALUE' && cond.values_type === 'string')) && (
        <>
          <TextField
            label="Value"
            value={cond.value || ''}
            onChange={e => onChange('value', e.target.value)}
            state={attemptedSubmit && !cond.value ? 'error' : 'default'}
            helperText={attemptedSubmit && !cond.value ? 'Value is required' : undefined}
          />
          <Spacer size="sm" />
        </>
      )}
      {cond.type === 'MULTIPLE_VALUE' && cond.values_type === 'array' && (
        <ValuesMultipleSelect
          values={cond.values || []}
          onChange={val => onChange('values', val)}
          placeholder="Add value and press Enter"
          label="Values"
          state={attemptedSubmit && !cond.values ? 'error' : 'default'}
          helperText={attemptedSubmit && !cond.values ? 'Values are required' : undefined}
        />
      )}
      {cond.type === 'MULTIPLE_VALUE' && (
        <ArrayMethodSelect
          value={cond.array_method || ''}
          onChange={val => onChange('array_method', val)}
          state={attemptedSubmit && !cond.array_method ? 'error' : 'default'}
          helperText={attemptedSubmit && !cond.array_method ? 'Array method is required' : undefined}
        />
      )}
      {onRemove && <CloseButton size="0.7rem" contrast clickCallback={onRemove} />}
    </Container>
  )
}

const Container = styled.div`
  border: 1px solid #d0d0d0;
  border-radius: 6px;
  margin: 0.75rem 0;
  padding: 1rem;
  position: relative;
`

export default ConditionCard
